import { GetITileDataByInstitutionIdAndTrialViewCodeResponse } from "@/api/dtos";
import TileDataContext from "@/contexts/Tiles/TileDataContext";
import useTileData from "@/hooks/tiles/useTileData";
import { FC, PropsWithChildren } from "react";
import { useParams } from "react-router";



export interface ITileDataProps {
    initial?: GetITileDataByInstitutionIdAndTrialViewCodeResponse;
    trialId: number;
    apiLinks: string[];
}

export const TileDataProvider: FC<PropsWithChildren<ITileDataProps>> = ({ initial, children, trialId, apiLinks }) => {
    const institutionId = useParams()?.institutionId;

    const tileData = useTileData(trialId, institutionId, apiLinks, {fallbackData: initial});

    return (
        <TileDataContext.Provider value={tileData}>
            {children}
        </TileDataContext.Provider>
    );
}

export default TileDataProvider;
